export default __webpack_public_path__ + "static/media/iphone_black_2.d58824e0.png";